import PropTypes from 'prop-types';
import { Link } from 'components/UI/Link/Link';
import { HighlightLabel } from 'components/UI/HighlightLabel/HighlightLabel';
import './EventTileInfo.scss';

const EventTileInfo = (props) => {
  const { url, title, genre, eventTime, venue, label, collapseOnMobile } = props;

  return (
    <div className="event-info">
      <div className="title" data-testid="title">
        <Link href={url} variant="secondary" noUnderline>
          {title}
        </Link>
      </div>

      <small className="genre">{genre}</small>

      {label && collapseOnMobile && <HighlightLabel>{label}</HighlightLabel>}

      {eventTime && (
        <div className="time" data-testid="time">
          {eventTime}
        </div>
      )}

      <div className="venue truncate" data-testid="venue">
        <span>{venue}</span>
      </div>
    </div>
  );
};

EventTileInfo.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  genre: PropTypes.string.isRequired,
  eventTime: PropTypes.string.isRequired,
  venue: PropTypes.string.isRequired,
  label: PropTypes.string,
  collapseOnMobile: PropTypes.bool,
};

export default EventTileInfo;
